export const doubleDigestNumer = (number: number): string => {
  return ('0' + number.toString()).slice(-2);
};

export const parseDate = (date: string): Date => {
  return new Date(date.replace(/-/g, '/'));
};
